import { createSlice } from "@reduxjs/toolkit";
import { getSlotsAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getSlotsSlice = createSlice({
  name: "getSlots",
  initialState: data,
  reducers: {
   getSlotsSlice(state) {
      state.isLoading = true;
    },
   getSlotsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getSlotsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getSlotsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getSlotsHandler: any = (id:any,data:any) => async (dispatch: any) => {
  try {
    dispatch(getSlotsAction.getSlotsSlice());
    const response: any = await getSlotsAPI(id,data);
    
    dispatch(getSlotsAction.getSlotsSliceSuccess(response));
  } catch (e: any) {
    dispatch(getSlotsAction.getSlotsSliceFailure(e?.response?.data));
  }
};
export default getSlotsSlice.reducer;
export const getSlotsAction = getSlotsSlice.actions;
